import { queryOptions } from "@tanstack/react-query";
import type {
  FindPackageByIdOutputDto,
  FindPackagesOutputDto,
} from "@/app/lib/types/codegen";

import api from "../api/api";

export const tripQueryOptions = (tripId: string) =>
  queryOptions({
    queryKey: ["packages", tripId],
    queryFn: ({ signal }) =>
      api.get<FindPackageByIdOutputDto>(`/packages/packages/${tripId}`, {
        signal,
      }),
    select: (response) => response.data.data,
    throwOnError: false,
  });

export const tripsQueryOptions = () =>
  queryOptions({
    queryKey: ["packages"],
    queryFn: ({ signal }) =>
      api.get<FindPackagesOutputDto>("/packages/packages", {
        signal,
      }),
    select: (response) => response.data.data.packages,
    throwOnError: false,
  });
